import { PriorityShapes } from '../enums/PriorityShapes';
import { IPolygonPoint } from '../interfaces';
import { ShapeManager } from '../managers';
import { ShapesFactory } from './shapes.factory';

export class PriorityShapesFactory {

  private readonly _shapesFactory = new ShapesFactory();

  public getPriorityShapePolygon(shapeType: PriorityShapes): string {
    switch (shapeType) {
      case PriorityShapes.RECTANGLE:
        return ShapeManager.formatPolygonFromPoints(this.getPriorityShapePolygonPoints(shapeType));
      case PriorityShapes.CIRCLE:
        return ShapeManager.formatPolygonFromPoints(this.getPriorityShapePolygonPoints(shapeType));
      case PriorityShapes.TRIANGLE:
        return ShapeManager.formatPolygonFromPoints(this.getPriorityShapePolygonPoints(shapeType));
      default:
        return ShapeManager.formatPolygonFromPoints(this.getPriorityShapePolygonPoints(shapeType));
    }
  }

  public getPriorityShapePolygonPoints(shapeType: PriorityShapes): IPolygonPoint[] {
    switch (shapeType) {
      case PriorityShapes.RECTANGLE:
        return this._shapesFactory.getShapePolygonPoints('square');
      case PriorityShapes.CIRCLE:
        return this._shapesFactory.getShapePolygonPoints('circle');
      case PriorityShapes.TRIANGLE:
        return this._shapesFactory.getShapePolygonPoints('triangle');
    }
  }
}
